/**
 * Created by etsay on 15.12.16.
 */
import {BonusScene} from 'bonus_scene';

import {Animation} from 'animation';

import {Button} from 'button';

import { GAME_TYPE } from "network/network_api";

const Sprite = PIXI.Sprite;
const TextureCache = PIXI.utils.TextureCache;
const BitmapText = PIXI.extras.BitmapText;

export default class BonusGameScene extends BonusScene {

    constructor(secondChanceTreshold) {
        super();

        this.secondChanceTreshold = secondChanceTreshold;
        //координаты веревок
        this.coordLeaves = {
            x: [280, 253, 221, 164],
            y: [280, 360, 460, 580],
            xOffset: [125, 140, 165, 187]
        };

        this.frogScale = [0.65, 0.75, 0.85, 1.0];

        function WavesFilter() {
            var vertexShader = null;
            var fragmentShader = [
                'precision mediump float;',
                '',
                'varying vec2 vTextureCoord;',
                'uniform sampler2D texture;',
                'uniform float iTime;',
                '',
                'void main()',
                '{',
                'float frequency=500.0;',
                'float amplitude=0.001;',
                'float speed=10.0;',
                'float distortion=sin(vTextureCoord.y*frequency+iTime*speed)*amplitude;',
                '    vec4 wave = texture2D(texture, vec2(vTextureCoord.x, vTextureCoord.y+distortion));',
                '    gl_FragColor = wave;',
                '}'
            ].join('\n');

            PIXI.AbstractFilter.call(this,
                vertexShader,
                fragmentShader
            );
        }

        WavesFilter.prototype = Object.create(PIXI.AbstractFilter.prototype);
        WavesFilter.prototype.constructor = WavesFilter;

        this.background = new PIXI.Sprite(PIXI.utils.TextureCache["res/bonus_background_sea.png"]);

        this.filter = new WavesFilter();
        this.filter.autoFit = true;
        this.filter.enabled = true;

        this.filter.uniforms.iTime = 0.0;

        this.background.filters = [this.filter];

        this.background.position.set(0, 150);
        this.background.visible = true;
        this.addChild(this.background);

        this.background_up = new PIXI.Sprite(PIXI.utils.TextureCache["res/bonus_background_up.png"]);
        this.addChild(this.background_up);
        
        this.animCrocoTale = Animation.byFrameName("croco_tale_%03d.png", 10);
        this.animCrocoTale.animationSpeed = 0.1;
        this.animCrocoTale.anchor.set(0.5, 0.5);
        this.animCrocoTale.scale.set(0.65, 0.65);
        this.animCrocoTale.position.set(532, 190);
        this.animCrocoTale.loop = false;
        this.animCrocoTale.visible = false;
        this.addChild(this.animCrocoTale);

        this.animCrocoEyes = Animation.byFrameName("croco_eyes_%03d.png", 19);
        this.animCrocoEyes.animationSpeed = 0.1;
        this.animCrocoEyes.anchor.set(0.5, 0.5);
        this.animCrocoEyes.scale.set(0.65, 0.65);
        this.animCrocoEyes.position.set(532, 190);
        this.animCrocoEyes.loop = false;
        this.animCrocoEyes.visible = false;
        this.addChild(this.animCrocoEyes);

        this.animCircles = [];
        this.leaveButton = [];
        for (let i = 0; i < 4; ++i) {
            this.animCircles[i] = [];
            this.leaveButton[i] = [];
            for (let j = 0; j < 5; ++j) {
                const circle = Animation.byFrameName("leaves_circle_%03d.png", 7);
                circle.loop = false;
                circle.visible = false;
                circle.anchor.set(0.5, 0.5);
                circle.position.set(this.coordLeaves.x[i] + this.coordLeaves.xOffset[i] * j, this.coordLeaves.y[i]);
                circle.scale.set(this.frogScale[i], this.frogScale[i]);
                circle.animationSpeed = 0.2;
                this.addChild(circle);
                this.animCircles[i][j] = circle;

                const button_name = "leave_%03d".$(i * 5 + j) + ".png";
                const button_pressed_name = "pressed_leave_%03d".$(i * 5 + j) + ".png";

                const button = new Button(PIXI.utils.TextureCache[button_name],
                    PIXI.utils.TextureCache[button_name],
                    PIXI.utils.TextureCache[button_pressed_name],
                    PIXI.utils.TextureCache[button_name]);

                button.enabled = true;
                button.anchor.set(0.5, 0.5);
                button.position.set(this.coordLeaves.x[i] + this.coordLeaves.xOffset[i] * j, this.coordLeaves.y[i]);

                // вызываем обработчик, в качестве параметра передаем индекс кнопки в массиве и делаем кнопку неактивной
                button.on('pointerdown', () => {
                    this.leaveButton[i][j].enabled = false;
                    // this.visible = false;
                    this.onUserSelect(j);
                });

                this.addChild(button);
                //button.enabled = false;
                this.leaveButton[i][j] = button;
            }
        }

        this.frog_leave = new PIXI.Sprite(PIXI.utils.TextureCache["frog_leave.png"]);
        this.frog_leave.position.set(470, 190);
        this.addChild(this.frog_leave);

        this.foreground_bottom_left = new PIXI.Sprite(PIXI.utils.TextureCache["bottom_left.png"]);
        this.foreground_bottom_left.position.set(0, 503);
        this.addChild(this.foreground_bottom_left);

        this.foreground_bottom_right = new PIXI.Sprite(PIXI.utils.TextureCache["bottom_right.png"]);
        this.foreground_bottom_right.position.set(840, 598);
        this.addChild(this.foreground_bottom_right);

        this.foreground_island_left = new PIXI.Sprite(PIXI.utils.TextureCache["island_left.png"]);
        this.foreground_island_left.position.set(0, 0);
        this.addChild(this.foreground_island_left);

        this.foreground_island_right = new PIXI.Sprite(PIXI.utils.TextureCache["island_right.png"]);
        this.foreground_island_right.position.set(761, 40);
        this.addChild(this.foreground_island_right);

        this.animLose = Animation.byFrameName("bonus_frog_lose_%03d.png", 16);
        this.animLose.animationSpeed = 0.1;
        this.animLose.anchor.set(0.5, 0.5);
        this.animLose.scale.set(0.65, 0.65);
        this.animLose.position.set(532, 190);
        this.animLose.loop = false;
        this.animLose.visible = false;
        this.addChild(this.animLose);

        this.animCrocoEating = Animation.byFrameName("croco_happy_%03d.png", 32);
        this.animCrocoEating.animationSpeed = 0.1;
        this.animCrocoEating.anchor.set(0.5, 0.5);
        this.animCrocoEating.scale.set(0.65, 0.65);
        this.animCrocoEating.position.set(532, 190);
        this.animCrocoEating.loop = false;
        this.animCrocoEating.visible = false;
        this.addChild(this.animCrocoEating);

        this.animSecondChance = Animation.byFrameName("croco_second_chance_%03d.png", 26);
        this.animSecondChance.animationSpeed = 0.1;
        this.animSecondChance.anchor.set(0.5, 0.5);
        this.animSecondChance.scale.set(0.65, 0.65);
        this.animSecondChance.position.set(532, 190);
        this.animSecondChance.loop = false;
        this.animSecondChance.visible = false;
        this.addChild(this.animSecondChance);

        // Анимация ожидания выбора игрока
        this.animIdle = Animation.byFrameName("bonus_frog_wait_%03d.png", 22);
        this.animIdle.animationSpeed = 0.3;
        this.animIdle.loop = true;
        this.animIdle.anchor.set(0.5, 0.5);
        this.animIdle.scale.set(0.65, 0.65);
        this.animIdle.position.set(532, 190);
        this.addChild(this.animIdle);

        this.animJump = Animation.byFrameName("bonus_frog_jump_%03d.png", 9);
        this.animJump.animationSpeed = 0.1;
        this.animJump.anchor.set(0.5, 0.5);
        this.animJump.scale.set(0.65, 0.65);
        this.animJump.position.set(532, 190);
        this.animJump.loop = false;
        this.animJump.visible = false;
        this.addChild(this.animJump);

        this.plateForBet = new PIXI.Sprite(PIXI.utils.TextureCache["plate_for_bet.png"]);
        this.plateForBet.position.set(250, 692);
        this.addChild(this.plateForBet);
        this.plateBetLabel = new PIXI.Sprite(PIXI.utils.TextureCache["bonus_total_bet.png"]);
        this.plateBetLabel.position.set(250, 748);
        this.addChild(this.plateBetLabel);
        this.totalBetLabel = new PIXI.extras.BitmapText("", {font: "status-font", align: "left"});//new PIXI.extras.BitmapText("", {font: "bonus-font", align: "left"});
        this.totalBetLabel.position.set(65, 25);
        this.totalBetLabel.anchor.set(0.5, 0);
        this.plateForBet.addChild(this.totalBetLabel);
        this.plateForWin = new PIXI.Sprite(PIXI.utils.TextureCache["plate_for_win.png"]);
        this.plateForWin.position.set(400, 690);
        this.addChild(this.plateForWin);
        this.plateWinLabel = new PIXI.Sprite(PIXI.utils.TextureCache["bonus_winner_paid.png"]);
        this.plateWinLabel.position.set(422, 748);
        this.addChild(this.plateWinLabel);
        this.winLabel = new PIXI.extras.BitmapText("", {font: "status-font", align: "left"});//new PIXI.extras.BitmapText("", {font: "bonus-font", align: "left"});
        this.winLabel.position.set(102, 26);
        this.winLabel.anchor.set(0.5, 0);
        this.plateForWin.addChild(this.winLabel);
        this.plateForCredits = new PIXI.Sprite(PIXI.utils.TextureCache["plate_for_credits.png"]);
        this.plateForCredits.position.set(610, 690);
        this.addChild(this.plateForCredits);
        this.plateCreditsLabel = new PIXI.Sprite(PIXI.utils.TextureCache["bonus_credits.png"]);
        this.plateCreditsLabel.position.set(697, 748);
        this.addChild(this.plateCreditsLabel);
        this.creditLabel = new PIXI.extras.BitmapText("", {font: "status-font", align: "left"});//new PIXI.extras.BitmapText("", {font: "bonus-font", align: "left"});
        this.creditLabel.position.set(138, 26);
        this.creditLabel.anchor.set(0.5, 0);
        this.plateForCredits.addChild(this.creditLabel);

        this.animSuberbonusWin = Animation.byFrameName("res/to_superbonus/superbonus_win_%03d.jpg", 14);
        this.animSuberbonusWin.animationSpeed = 0.2;
        this.animSuberbonusWin.anchor.set(0.7, 0.55);
        this.animSuberbonusWin.position.set(717, 422);
        this.animSuberbonusWin.loop = false;
        this.animSuberbonusWin.visible = false;
        this.addChild(this.animSuberbonusWin);

        this.animSuberbonusBubbles = Animation.byFrameName("sb_bubbles_%03d.png", 12);
        this.animSuberbonusBubbles.animationSpeed = 0.3;
        this.animSuberbonusBubbles.position.set(-104, -82);
        this.animSuberbonusBubbles.loop = true;
        this.animSuberbonusBubbles.visible = false;
        this.animSuberbonusWin.addChild(this.animSuberbonusBubbles);

        this.sb_fishes = [];
        this.greenFish = new PIXI.Sprite(PIXI.utils.TextureCache["fish_0.png"]);
        this.greenFish.position.set(350, -150);
        this.greenFish.visible = false;
        this.animSuberbonusWin.addChild(this.greenFish);
        this.sb_fishes.push(this.greenFish);

        this.yellowFish = new PIXI.Sprite(PIXI.utils.TextureCache["fish_1.png"]);
        this.yellowFish.position.set(350, -100);
        this.yellowFish.visible = false;
        this.animSuberbonusWin.addChild(this.yellowFish);
        this.sb_fishes.push(this.yellowFish);

        this.blueFish = new PIXI.Sprite(PIXI.utils.TextureCache["fish_2.png"]);
        this.blueFish.position.set(350, 50);
        this.blueFish.visible = false;
        this.animSuberbonusWin.addChild(this.blueFish);
        this.sb_fishes.push(this.blueFish);

        this.addWinLabel = [];
        for (let i = 0; i < 4; i++) {
            const label = new PIXI.extras.BitmapText("", {font: "bonus_font", align: "center"});
            label.anchor.set(0.5, 0.5);
            label.position.set(this.coordLeaves.x[0], this.coordLeaves.y[i]);
            label.visible = false;
            this.addChild(label);
            this.addWinLabel.push(label);
        }

        this.sndFon = sounds.get("res/sounds/bonus/background");
        this.sndFon.loop(true);
        this.sndLose = sounds.get("res/sounds/bonus/snake_eat");
        this.sndSecondChance = sounds.get("res/sounds/bonus/snake_second_chance");
        this.sndFrogSink = sounds.get("res/sounds/bonus/frog_sink");
        this.sndSuperbonusStart = sounds.get("res/sounds/bonus/superbonus_enter");
        this.sndFlow = sounds.get("res/sounds/bonus/creditsflow");
        this.sndFlow.loop(true);

        this.winTable = [];
        this.currentWinIndex = 0;
        this.queueFlow = []; // массив для порядка перетеканя выигрыша в конце бонуса
    }

    terminate() {
        this.coordLeaves = null;
        this.background = null;
        this.background_up = null;
        this.plateForBet = null;
        this.plateBetLabel = null;
        this.totalBetLabel = null;
        this.plateForWin = null;
        this.plateWinLabel = null;
        this.winLabel = null;
        this.plateForCredits = null;
        this.plateCreditsLabel = null;
        this.creditLabel = null;
        this.animCircles = null;
        this.leaveButton = null;
        this.animIdle.stop();
        this.animIdle = null;
        this.animJump.stop();
        this.animJump = null;
        this.animCrocoEating.stop();
        this.animCrocoEating = null;
        this.animLose.stop();
        this.animLose = null;
        this.animCrocoTale.stop();
        this.animCrocoTale = null;
        this.animCrocoEyes.stop();
        this.animCrocoEyes = null;
        this.animSecondChance.stop();
        this.animSecondChance = null;
        this.frog_leave = null;
        this.foreground_bottom_left = null;
        this.foreground_bottom_right = null;
        this.foreground_island_left = null;
        this.foreground_island_right = null;
        this.animSuberbonusWin.stop();
        this.animSuberbonusWin = null;
        this.animSuberbonusBubbles.stop();
        this.animSuberbonusBubbles = null;
        this.sb_fishes = null;
        this.addWinLabel = null;
        this.sndFon.stop();
        this.sndFon = null;
        this.sndLose.stop();
        this.sndLose = null;
        this.sndSecondChance.stop();
        this.sndSecondChance = null;
        this.sndFrogSink.stop();
        this.sndFrogSink = null;
        this.sndSuperbonusStart.stop();
        this.sndSuperbonusStart = null;
        this.sndFlow.stop();
        this.sndFlow = null;
        this.winTable = null;
        this.currentWinIndex = null;
        this.queueFlow = null;

        this.removeChildren();
        this.destroy();
    }

    // update (dt, time) {
    //     this.filter.uniforms.iTime += dt;
    //     // console.log("TIC");
    // }

    // Восстановление сцены без учета ее прошлого состояния
//     resume = function (data) {
//         Scene.prototype.resume.call(this);
//
//         console.log("RESUME BONUS WITH DATA: " + JSON.stringify(data));
//
//         //обнулим перед каждым бонусом
//         this.queueFlow.length = 0;
//
//         this.totalBetLabel.text = data.totalBet.toString();
//         this.winLabel.text = data.currentWin.toString();
//         this.creditLabel.text = data.credits.toString();
//
//         this.currentWinIndex = 0;
//         this.winTable = [0, 0, 0, 0, 0];
//
//         for (var i = 0; i < this.leaveButton.length; i++) {
//             this.leaveButton[i].visible = true;
//             var currentFrame = Math.floor(Math.random() * 9);
//             this.leaveButton[i].gotoAndPlay(currentFrame);
//             // this.doorButton[i].enabled = !this.observerMode;
//         }
//
//         this.animIdle.position.set(0, 288);
//         this.animIdle.visible = true;
//         this.animIdle.gotoAndPlay(0);
//
//         this.sndFon.play();
//
//         if (data.previousStepsData) {
//             // Отрисовываем заново предыдущие выигрыши (кроме последнего)
//             for (var i = 0; i < data.previousStepsData.length - 1; i++) {
//                 var owen = data.previousStepsData[i];
//                 var win = data.previousWins[i] * this.model.bet;
//
//                 this.leaveButton[owen].interactive = false;
//                 this.leaveButton[owen].visible = false;
//
//                 this.addWinLabel[owen].text = win;
//                 this.addWinLabel[owen].visible = true;
//                 this.winTable[owen] = win;
//             }
//         }
//     };
//
//     BonusScene
// .
//     prototype
// .
//     pause = function () {
//         Scene.prototype.pause.call(this);
//         this.disableButtons();
//         this.animIdle.visible = false;
//         this.animIdle.gotoAndStop(0);
//         this.animOpen.visible = false;
//         this.animOpen.gotoAndStop(0);
//         this.animLose.visible = false;
//         this.animLose.gotoAndStop(0);
//         for (var i = 0; i < 5; i++) {
//             this.leaveButton[i].visible = false;
//             this.leaveButton.interactive = false;
//             this.addWinLabel[i].visible = false;
//         }
//         for (var i = 0; i < 4; i++) {
//             this.elements[i].visible = false;
//         }
//
//         this.sndFon.stop();
//         this.sndLose.stop();
//         this.sndWin.stop();
//         this.sndOpen.stop();
//         this.sndMonkeyStunned.stop();
//     };

    // Заблокировать все активные кнопки
    // @overridden
    selectionHasMade(variant) {
        for ( let i = 0; i < this.animCircles.length; ++i) {
            for (let j = 0; j < this.animCircles[i].length; ++j) {
                this.animCircles[i][j].gotoAndStop(0);
                this.animCircles[i][j].visible = false;
                this.leaveButton[i][j].enabled = false;
            }
        }
    }

    // Разблокировать все активные кнопки
    enableButtonsExclusive (selectedItems) {
        const step = selectedItems.length;
        for (let i = 0 ; i < this.leaveButton.length; ++i) {
            if (i === step) {
                for (let j = 0; j < this.leaveButton[i].length; ++j) {
                    this.leaveButton[i][j].enabled = true;
                    this.leaveButton[i][j].visible = true;
                }
            }
            else {
                for (let j = 0; j < this.leaveButton[i].length; ++j) {
                    this.leaveButton[i][j].enabled = false;
                }
            }
        }
    }

    // Перетекания выигрыша за призы после окончания бонуса
    flowWins (done) {

        // отсортируем массив по возрастанию
        // this.queueFlow.sort(function (a, b) {
        //     return a - b;
        // });

        console.log("queueFlow: ", this.queueFlow, + ", winTable: " + this.winTable);

        var self = this;

        // Массив твинов для перетекания каждого выигрыша отдельно
        const arrTweens = [];

        // Создаем твины
        for (let i = 0; i < this.queueFlow.length; i++) {

            if (this.winTable[i] > 0) {

                const idx = this.queueFlow[i];
                // берем значение из лейбла
                const val = this.winTable[i];//+this.addWinLabel[this.queueFlow[i]].text;
                const time = 100 * Math.log(val);

                const win = {
                    value: val,
                    index: i,
                    from: val
                };

                const flowTween = new TWEEN.Tween(win)
                    .to({value: 0}, time)
                    .onStart(() => {
                        if (!self.sndFlow.playing()) self.sndFlow.play();
                    })
                    .onUpdate(function () {
                        const value = this.value | 0;
                        const delta = this.from - value;
                        this.from -= delta;

                        self.winLabel.text = parseInt(self.winLabel.text) + delta;
                        self.addWinLabel[this.index].text = value.toString();
                    })
                    .onComplete(function () {
                        self.addWinLabel[this.index].visible = false;
                        if (self.sndFlow.playing()) self.sndFlow.stop();
                    });
                arrTweens.push(flowTween);
            }
        }

        // создаем цепочку из tween'ов, что бы они запускались друг за другом, слева направо как в оригинале
        for (let i = 1; i < arrTweens.length; i++) {
            arrTweens[i - 1].chain(arrTweens[i]);
        }

        //последний заканчивает перетекание
        arrTweens[arrTweens.length - 1].onComplete(function () {
            for (let i = 0; i < self.addWinLabel.length; ++i) {
                self.addWinLabel[i].visible = false;
            }
            if (self.sndFlow.playing()) self.sndFlow.stop();
            // done();
            setTimeout(function () {
                self.sndFon.stop();
                done();
            }, 500);
        });

        arrTweens[0].delay(1000)
            .start();
    }

    showSuperbonus (scenarioData, done) {
        console.log("GAME_TYPE.BONUS_2");

        this.fishTween = [];
        this.queueFlow = scenarioData.slice();
        this.flowWins(()=> {
            this.animSuberbonusWin.alpha = 1;
            this.animSuberbonusWin.visible = true;
            this.animSuberbonusWin.gotoAndPlay(0);
            this.sndFon.stop();
            this.sndSuperbonusStart.play();

            for (let i = 0; i < this.sb_fishes.length; ++i) {
                this.sb_fishes[i].visible = true;
                this.fishTween[i] = new TWEEN.Tween(this.sb_fishes[i].position)
                    .to({x: -700}, 3000)
                    .delay(i*500)
                    .start();
            }

            this.animSuberbonusWin.onComplete = () => {
                this.animSuberbonusBubbles.gotoAndPlay(0);
                this.animSuberbonusBubbles.visible = true;

                this.scaleSbWinTween = new TWEEN.Tween(this.animSuberbonusWin.scale)
                    .to({x: 5.12, y: 4.8}, 1500)
                    .onComplete(() => {
                        done();
                        this.fadeOutTween = new TWEEN.Tween(this.animSuberbonusWin)
                            .to({alpha: 0}, 300)
                            .onComplete(() => {
                                this.animSuberbonusWin.alpha = 1;
                                this.animSuberbonusWin.visible = false;
                                this.animSuberbonusWin.gotoAndStop(0);
                                this.animSuberbonusWin.scale.x = 1;
                                this.animSuberbonusWin.scale.y = 1;
                                this.animSuberbonusBubbles.gotoAndStop(0);
                                this.animSuberbonusBubbles.visible = false;
                                this.sndFon.stop();
                                for (let i = 0; i < this.sb_fishes.length; ++i) {
                                    this.sb_fishes[i].visible = false;
                                    this.sb_fishes[i].position.x = 350;
                                    this.fishTween[i].stop();
                                }
                                this.sndSuperbonusStart.stop();
                                done();
                            })
                            .start();
                    })
                    .start();
            };
        });
    }

    // показ исхода бонуса
    // @overridden
    showResult (data, done) {

        console.log("SHOW BONUS RESULT WITH DATA: " , data);

        const scenarioData = data.server.scenarioData || [];
        console.log( 'scenarioData:', scenarioData )
        const bet = data.server.price();
        //обнулим перед каждым бонусом
        this.queueFlow.length = 0;

        let chanceUsed = false;
        // const needUsedHelmet = data.state.stage.math.useNextChance;
        //
        this.totalBetLabel.text = bet;
        this.creditLabel.text = data.server.credits;
        //
        let currentWin = data.server.totalWinInCoins;

        this.currentWinIndex = 0;
        this.winTable = [0, 0, 0, 0, 0];

        for (let i = 0; i < this.leaveButton.length; ++i) {
            for (let j = 0; j < this.leaveButton[i].length; ++j) {
                this.leaveButton[i][j].visible = true;
                this.leaveButton[i][j].enabled = true;
            }
        }
        this.frog_leave.visible = true;
        this.animIdle.scale.set(0.65, 0.65);
        this.animIdle.position.set(532, 190);
        this.animJump.scale.set(0.65, 0.65);
        this.animJump.position.set(532, 190);

        // все предыущие элементы отрисованы должны быть заранее
        if (data.state.stage.math.bonus1Wins) {
            this.frog_leave.visible = false;
            for (let i = 0; i < scenarioData.length - 1; i++) {

                const owen = scenarioData[i];
                const win = data.state.stage.math.bonus1Wins[i] * data.server.betValue.multiplier;

                if (data.state.stage.math.bonus1Wins[i] > 0) {
                    currentWin -= data.state.stage.math.bonus1Wins[i] * data.server.betValue.multiplier;
                    this.addWinLabel[i].text = win;
                    this.addWinLabel[i].visible = true;
                    this.addWinLabel[i].position.x = this.coordLeaves.x[i] + this.coordLeaves.xOffset[i] * owen;
                    this.winTable[i] = win;
                    this.currentWinIndex++;
                }

                if (data.state.stage.math.bonus1Wins[i] === -1 && i < data.state.stage.math.bonus1Wins.length - 1) {
                    chanceUsed = true;
                }

                for (let j = 0; j < this.leaveButton[i].length; ++j) {
                    this.leaveButton[i][j].enabled = false;
                    this.leaveButton[i][j].visible = false;
                }
            }
            currentWin -= data.state.stage.math.bonus1Wins[data.state.stage.math.bonus1Wins.length-1] * data.server.betValue.multiplier;

            if (scenarioData.length > 1) {
                const index = scenarioData[scenarioData.length - 2];
                const step = scenarioData.length - 2;

                this.animIdle.scale.set(this.frogScale[step], this.frogScale[step]);
                this.animIdle.position.set(this.coordLeaves.x[step] + this.coordLeaves.xOffset[step] * index, this.coordLeaves.y[step]);
                this.animJump.scale.set(this.frogScale[step], this.frogScale[step]);
                this.animJump.position.set(this.coordLeaves.x[step] + this.coordLeaves.xOffset[step] * index - 7, this.coordLeaves.y[step] - 50);
            }
        }
        const secondChance = data.state.stage.math.useSecondChance || false;

        this.winLabel.text = currentWin;
        //
        // this.animIdle.position.set(0, 307);
        // this.animIdle.visible = true;
        this.animIdle.gotoAndPlay(0);
        //
        // this.helmet.visible = !helmetUsed && secondChance;
        //
        if(!this.sndFon.playing()) this.sndFon.play();
        //
        // // data.math.bonus1WinCoefs  массив выигрышей
        // // data.scenarioData         массив выбора игроком в бонусе если сейчас бонус
        // // data.scenarioData         массив выбора игроком в супербонусе если сейчас супербонус
        //
        // // самый последний элемент - то что анимируем - перемещается бабушка, открывается дверь и т.д.
        // // все предыдущие элементы обоих массивов - отрисованы должны быть заранее (даже повторно - ничего страшного)
        //
        // // после окончания визуализации вызвать done()
        //
        var self = this;
        //var data = data;
        if (scenarioData && scenarioData.length > 0) {
            this.selectionHasMade(scenarioData[scenarioData.length - 1]);

            const index = scenarioData[scenarioData.length - 1];
            const step = scenarioData.length - 1;

            console.log("INDEX = " + index + ", STEP = " + step);

            const winInBet = data.state.stage.math.bonus1Wins[data.state.stage.math.bonus1Wins.length - 1];

            this.animIdle.visible = false;
            this.animJump.visible = true;
            this.animJump.gotoAndPlay(0);

            this.frogJump = new TWEEN.Tween(this.animJump.position)
                .to({x: this.coordLeaves.x[step] + this.coordLeaves.xOffset[step] * index - 7, y: this.coordLeaves.y[step] - 50}, 1000)
                .onComplete(() =>  {
                    this.animJump.visible = false;
                    this.animJump.scale.set(this.frogScale[step], this.frogScale[step]);

                    if (winInBet > 0) {
                        this.addWinLabel[step].text = winInBet * data.server.betValue.multiplier;
                        this.winTable[step] = winInBet * data.server.betValue.multiplier;//self.winTable.push(winInBet*self.model.bet);
                        this.addWinLabel[step].position.x = this.coordLeaves.x[step] + this.coordLeaves.xOffset[step] * index;
                        this.addWinLabel[step].visible = true;

                        this.leaveDown = new TWEEN.Tween(this.leaveButton[step][index].position)
                            .to({y: this.coordLeaves.y[step] + 10}, 300)
                            .repeat(1)
                            .yoyo(true)
                            .start();

                        this.animCircles[step][index].visible = true;
                        this.animCircles[step][index].gotoAndPlay(0);
                        this.animCircles[step][index].onComplete = () => {
                            this.animCircles[step][index].visible = false;
                            this.animCircles[step][index].gotoAndStop(0);
                        }
                    }
                })
                .start();

            this.frogEnlarge = new TWEEN.Tween(this.animJump.scale)
                .to({x: this.frogScale[step], y: this.frogScale[step]}, 1000)
                .onComplete(() => {
                    // продолжаем бонус
                    if (winInBet > 0) {
                        this.animIdle.scale.set(this.frogScale[step], this.frogScale[step]);
                        this.animIdle.position.set(this.coordLeaves.x[step] + this.coordLeaves.xOffset[step] * index, this.coordLeaves.y[step]);
                        this.animIdle.visible = true;
                        this.animIdle.gotoAndPlay(0);

                        this.frogDown = new TWEEN.Tween(this.animIdle.position)
                            .to({y: this.coordLeaves.y[step] + 10}, 300)
                            .repeat(1)
                            .yoyo(true)
                            .start();

                        for (let i = 0; i < this.leaveButton[step].length; ++i) {
                            if (i !== index) this.leaveButton[step][i].visible = false;
                        }

                        if (data.server.isBonusAvailable(GAME_TYPE.BONUS_2)) {
                            this.showSuperbonus(scenarioData, done);
                        }
                        else {
                            const timeout = Math.floor(Math.random() * 7);

                            let animation = this.animCrocoTale;
                            timeout % 2 === 0 ? animation = this.animCrocoEyes : this.animCrocoTale;

                            const croco_position = Math.floor(Math.random() * 4);
                            setTimeout(() => {
                                this.animCrocoEyes.visible = false;
                                this.animCrocoEyes.gotoAndStop(0);
                                this.animCrocoTale.visible = false;
                                this.animCrocoTale.gotoAndStop(0);
                                animation.position.y = step > 0 ? this.coordLeaves.y[step - 1] : 190;
                                animation.position.x = this.coordLeaves.x[step] + this.coordLeaves.xOffset[step] * croco_position;
                                animation.gotoAndPlay(0);
                                animation.visible = true;
                            }, timeout * 100);
                            animation.onComplete = () => {
                                animation.gotoAndStop(0);
                                animation.visible = false;
                            };
                            self.enableButtonsExclusive(scenarioData);
                            done();
                        }
                    }
                    else {
                        this.animLose.scale.set(this.frogScale[step], this.frogScale[step]);
                        this.animLose.position.set(this.coordLeaves.x[step] + this.coordLeaves.xOffset[step] * index, this.coordLeaves.y[step] - 10);
                        this.animLose.visible = true;
                        this.animLose.gotoAndPlay(0);
                        this.sndFrogSink.play();
                        for (let i = 0; i < this.leaveButton[step].length; ++i) {
                            this.leaveButton[step][i].visible = false;
                        }
                    }
                })
                .start();

            this.animLose.onComplete = () => {
                this.sndFrogSink.stop();
                this.animLose.visible = false;
                if (secondChance) {
                    this.animSecondChance.scale.set(this.frogScale[step], this.frogScale[step]);
                    this.animSecondChance.position.set(this.coordLeaves.x[step] + this.coordLeaves.xOffset[step] * index, this.coordLeaves.y[step] - 85);
                    this.animSecondChance.visible = true;
                    this.animSecondChance.gotoAndPlay(0);
                    this.sndSecondChance.play();
                    this.animSecondChance.onComplete = () => {
                        this.sndSecondChance.stop();
                        this.animSecondChance.visible = false;
                        this.leaveButton[step][index].visible = true;
                        this.animIdle.scale.set(this.frogScale[step], this.frogScale[step]);
                        this.animIdle.position.set(this.coordLeaves.x[step] + this.coordLeaves.xOffset[step] * index, this.coordLeaves.y[step]);
                        this.animIdle.visible = true;
                        this.animIdle.gotoAndPlay(0);
                        this.enableButtonsExclusive(scenarioData);

                        if (data.server.isBonusAvailable(GAME_TYPE.BONUS_2)) {
                            this.showSuperbonus(scenarioData, done);
                        }
                        else done();
                    }
                }
                else {
                    this.animCrocoEating.scale.set(this.frogScale[step], this.frogScale[step]);
                    this.animCrocoEating.position.set(this.coordLeaves.x[step] + this.coordLeaves.xOffset[step] * index, this.coordLeaves.y[step]);
                    this.animCrocoEating.visible = true;
                    this.animCrocoEating.gotoAndPlay(0);
                    this.sndLose.play();
                }
            };

            this.animCrocoEating.onComplete = () => {
                this.animCrocoEating.gotoAndStop(0);
                this.animCrocoEating.visible = false;
                this.sndLose.stop();
                // если были выигрыши
                if (self.currentWinIndex > 0) {
                    this.queueFlow = scenarioData.slice();
                    self.flowWins(() => {
                        done();
                    });
                }
                else {
                    setTimeout(done, 500);
                }
            };
        }
        else {
            this.animIdle.visible = true;
            for (let i = 1; i < this.leaveButton.length; i++) {
                for (let j = 0; j < this.leaveButton[i].length; ++j) {
                    this.leaveButton[i][j].visible = true;
                    this.leaveButton[i][j].enabled = false;
                    // this.addWinLabel[i].visible = false;
                }
            }
            for (let j = 0; j < this.leaveButton[0].length; ++j) {
                this.leaveButton[0][j].visible = true;
                this.leaveButton[0][j].enabled = true;
            }
            done();
        }
    }

    // @overridden
    showFinishTable(stageMath, bet, done) {

        console.log("bonus: showFinishTable");

        this.animSuberbonusWin.alpha = 1;
        this.animSuberbonusWin.visible = false;
        this.animSuberbonusWin.gotoAndStop(0);
        this.animSuberbonusWin.scale.x = 1;
        this.animSuberbonusWin.scale.y = 1;
        this.animSuberbonusBubbles.gotoAndStop(0);
        this.animSuberbonusBubbles.visible = false;
        this.sndFon.stop();
        this.blueFish.position.set(350, 50);
        this.yellowFish.position.set(350, -100);
        this.greenFish.position.set(350, -150);
        done();
    }
}



// WEBPACK FOOTER //
// ./src/bonusgame_scene.es6